export type StatusFilter = 'all' | 'open' | 'closed';

/** Preset key: 'today' | 'week' | 'month'. Exact/custom ranges use the range variant. */
export type DateFilterValue =
  | { type: 'preset'; key: string }
  | { type: 'range'; from: string; to: string }
  | null;

export const TX_TYPE_LABELS: Record<string, string> = {
  exchange: 'Обмен',
  deposit: 'Депозит',
  withdrawal: 'Вывод',
  expense: 'Расход',
  transfer: 'Перевод',
};

export const TX_TYPE_COLORS: Record<string, string> = {
  exchange: 'bg-ctp-green/15 text-ctp-green',
  deposit: 'bg-ctp-blue/15 text-ctp-blue',
  withdrawal: 'bg-ctp-red/15 text-ctp-red',
  expense: 'bg-ctp-peach/15 text-ctp-peach',
  transfer: 'bg-ctp-mauve/15 text-ctp-mauve',
};

export const CRYPTO_CURRENCIES = new Set(['USDT', 'BTC', 'ETH', 'USDC', 'BNB', 'SOL', 'XRP']);

export function exchangeSubtype(currencyIn: string | null | undefined): 'покупка' | 'продажа' {
  return CRYPTO_CURRENCIES.has(currencyIn?.toUpperCase() ?? '') ? 'продажа' : 'покупка';
}

export const DATE_PRESET_OPTIONS = [
  { value: 'today', label: 'Сегодня' },
  { value: 'week', label: 'Эта неделя' },
  { value: 'month', label: 'Этот месяц' },
];

export const TX_TYPE_FILTER_OPTIONS = [
  { value: 'exchange', label: 'Обмен' },
  { value: 'expense', label: 'Расход' },
  { value: 'deposit', label: 'Депозит' },
  { value: 'withdrawal', label: 'Вывод' },
  { value: 'transfer', label: 'Перевод' },
];
